<template>
  <div class="content">
      <b-row class="mt--4">
        <b-col lg="3" md="6">
          <router-link :to="{ name: 'dashboard', params: { id: getSelectedLoanId || this.$route.params.id, section: 'AUS' }}" id="stat-link">
            <stats-card title="Saved Result"
                        :type="getScenario.valid ? 'gradient-success' : 'gradient-danger'"
                        :sub-title="getScenario.valid ? 'Passes' : 'Fails'"
                        :icon="getScenario.valid ? 'fas fa-check' : 'fas fa-times'"
                        class="mb-4">

              <template slot="footer">
                <span class="">Save a different scenario for a new result</span>
              </template>
            </stats-card>
          </router-link>
        </b-col>
        <b-col lg="3" md="6">
          <router-link :to="{ name: 'compare', params: { id: getSelectedLoanId || this.$route.params.id }}" id="stat-link">
            <stats-card title="Last Saved"
                        type="gradient-warning"
                        :sub-title="getSavedTime === 'Invalid Date' ? 'No Saved Scenarios' : getSavedTime"
                        icon="fas fa-clock"
                        class="mb-4">

              <template slot="footer">
                <span class="mr-1" style="font-weight:600">{{getCompareOptions.length}}</span>
                <span class="">saved scenarios for this loan</span>
              </template>
            </stats-card>
          </router-link>
        </b-col>
        <b-col lg="3" md="6">
          <router-link :to="{ name: 'compensatingFactors', params: { id: getSelectedLoanId || this.$route.params.id }}" id="stat-link">
            <stats-card title="Valid Compensating Factors"
                        type="gradient-info"
                        :sub-title="String(getPassingCompFactorLength)"
                        icon="ni ni-chart-bar-32"
                        class="mb-4">

              <template slot="footer">
                <span style="font-weight:600">{{getCompFactorCount}}</span>
                <span class=""> compensating factors evaluated</span>
              </template>
            </stats-card> 
          </router-link>
        </b-col>
        <b-col lg="3" md="6">
          <!-- TODO: Sfigure out where to link to -->
          <router-link :to="{ name: 'dashboard', params: { id: getSelectedLoanId || this.$route.params.id, section: 'AUS' }}" id="stat-link">
            <stats-card title="Credit Report Status"
                        :type="getScenario.creditReportFound ? 'gradient-success' : 'secondary'"
                        :sub-title="getCreditReportStatus"
                        :icon="getScenario.creditReportFound ? 'fas fa-check' : 'fas fa-times text-danger'"
                        :class="getScenario.creditReportFound ? 'mb-4' : 'mb-4 bg-danger text'">

              <template slot="footer">
                <span>HALO <span style="font-weight:600">{{getScenario.creditReportFound ? 'WILL' : 'WILL NOT'}}</span> evaluate the credit report</span>
              </template>
            </stats-card>
          </router-link>
        </b-col>
      </b-row>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
export default {
  computed: {
    ...mapGetters(["getSaved", "getScenario", "getCompareOptions", "getPassingCompFactorLength", "getSelectedLoanId"]),
    getSavedTime(){
      const date = new Date(this.getScenario.created)
      return date.toLocaleString();
    },
    getCompFactorCount(){
      return String(this.getScenario.compensatingFactors.length)
    },
    getPassingCompFactorCount(){
      return String(this.getScenario.compensatingFactors.filter(cf => cf.valid).length)
    },
    getAdjustmentsCount(){
      return String(this.getScenario.adjustments.length)
    },
    getNonZeroAdjustmentsCount(){
      return String(this.getScenario.adjustments.filter(a => a.adjustment !== 0).length)
    },
    getCreditReportStatus() {
      return this.getScenario.creditReportFound ? 'Valid Report Found' : 'No Valid Report Found';
    },
    currentScenarioName(){
      let name = '';
      if (this.$route.name === 'scenarioTool') {
        name = 'toolScenario';
      } else {
        name = 'haloScenario';
      }
      return name;
    }
  },
  methods: {
    ...mapActions(["fetchScenarioTimes"]),
    ...mapMutations(["setPassingCompFactorLength"]),
    toggleSidebar() {
      this.$sidebar.displaySidebar(this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    }
  },
};
</script>

<style>
#stat-link {
  cursor: pointer;
  color: #525f7f !important;
}

.no-credit-report {
  background-color: #ff2e55;
}

.text h5{
  color: white !important;
}

.text .h2{
  color: white !important;
}

.text {
  color: white
}

.text-header {
  color: #333333
}
</style>